import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { buildingsRoutes } from './routes';
export class Buildings {
  constructor() {
    _defineProperty(this, "routes", buildingsRoutes);
  }
  async getBuilding(data, options) {
    const propertyId = data.propertyId;
    const resp = await requestService('aggregate').get(this.routes.getBuilding(propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getBuildingsBatch(data, options) {
    const propertyIds = data.propertyIds;
    const resp = await requestService('aggregate').post(this.routes.getBuildingsBatch, {
      propertyIds
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}